import {observer} from 'mobx-react';
import React from 'react';
import {TimeZoneComponentStore} from '../TimeZoneComponentStore';

@observer
export class EditTimeZoneForm extends React.Component<{ store: TimeZoneComponentStore }> {
  render() {
    if (this.props.store.editTimeZone === null)
      return null;

    const store = this.props.store.editTimeZone;
    const name = store.name;
    const offset = store.utcOffset;

    return (
      <div className="row" key="add-language-form">
        <div className="col">
          <div className={name.formGroupClassName}>
            <label>Time Zone Name</label>
            <input type="text" className="form-control"
                   value={name.value}
                   onChange={name.onChangeHandler}
                   onBlur={name.markTouched}/>
            <div className="invalid-text">Enter Time Zone name</div>
          </div>
        </div>
        <div className="col">
          <div className={offset.formGroupClassName}>
            <label>Utc Offset (in minutes)</label>
            <input type="text" className="form-control"
                   value={offset.value}
                   onChange={offset.onChangeHandler}
                   onBlur={offset.markTouched}/>
            <div className="invalid-text">Enter UTC Offset</div>
          </div>
        </div>
      </div>);
  }
}
